import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react"
import { Api_End_Parameters } from "./ApiEndParameters";
import { logout } from "../Features/authslice";

const ApiEndParameters = Api_End_Parameters;

export const EndPointsApis = createApi({
  reducerPath: 'EndPointsApis',
  baseQuery: async (args, api, extraOptions) => {
    const baseQuery = fetchBaseQuery({
      baseUrl: "https://afdapidev.azurewebsites.net/api/",
      // baseUrl: "https://afdapiuat.azurewebsites.net/api/",
      // baseUrl: 'https://afdapiprd.azurewebsites.net/api',

      prepareHeaders: (headers, { getState }: any) => {
        const token = getState().auth.token;
        if (token) {
          headers.set('authorization', `Bearer ${token}`);
        }
        if (!(args.body instanceof FormData)) {
          headers.set('Content-Type', 'application/json');
        }
        // headers.set('Content-Type', 'application/json');
        return headers;
      },
    });

    const result = await baseQuery(args, api, extraOptions);
    if (result.error && result.error.status === 401) {
      api.dispatch(logout());
    }

    return result;
  },
  endpoints: (builder) => ({
    loginUser: builder.mutation({
      query: (body) => {
        return {
          url: ApiEndParameters.LoginUser,
          method: "POST",
          body,
        }
      },
    }),
    renewToken: builder.mutation({
      query: (body) => {
        return {
          url: ApiEndParameters.renewToken,
          method: "POST",
          body,
        }
      },
    }),
    createUser: builder.mutation({
      query: (body) => {
        return {
          url: ApiEndParameters.createUser,
          method: "POST",
          body,
        }
      },
    }),
    createContact: builder.mutation({
      query: (body) => {
        return {
          url: ApiEndParameters.createContact,
          method: "POST",
          body,
        }
      },
    }),
    createTeam: builder.mutation({
      query: (body) => {
        return {
          url: ApiEndParameters.createTeam,
          method: "POST",
          body,
        }
      },
    }),
    createRoleWisePermissions: builder.mutation({
      query: (body) => {
        return {
          url: ApiEndParameters.roleWisePermissions,
          method: "POST",
          body,
        }
      },
    }),
    createLead: builder.mutation({
      query: (body) => {
        return {
          url: ApiEndParameters.createLead,
          method: "POST",
          body,
        }
      },
    }),
    createAccount: builder.mutation({
      query: (body) => {
        return {
          url: ApiEndParameters.createAccount,
          method: "POST",
          body,
        }
      },
    }),

    createAppointment: builder.mutation({
      query: (body) => {
        return {
          url: ApiEndParameters.createAppointment,
          method: "POST",
          body,
        }
      },
    }),
    createAppointmentResult: builder.mutation({
      query: (body) => {
        return {
          url: ApiEndParameters.CreateAptResult,
          method: "POST",
          body,
        }
      },
    }),
    upsertJobScope: builder.mutation({
      query: (body) => {
        return {
          url: ApiEndParameters.upsertJobScope,
          method: "POST",
          body,
        }
      },
    }),
    upsertProjectNotes: builder.mutation({
      query: (body) => {
        return {
          url: ApiEndParameters.upsertProjectNotes,
          method: "POST",
          body,
        }
      },
    }),
    createUpdateContigency: builder.mutation({
      query: (body) => {
        return {
          url: ApiEndParameters.createUpdateContigency,
          method: "POST",
          body,
        }
      },
    }),
    createUpdateProjectTasks: builder.mutation({
      query: (body) => {
        return {
          url: ApiEndParameters.createUpdateProjectTask,
          method: "POST",
          body,
        }
      },
    }),
    createUpdateFunding: builder.mutation({
      query: (body) => {
        return {
          url: ApiEndParameters.createUpdateFunding,
          method: "POST",
          body,
        }
      },
    }),
    createUpdateSpecificationException: builder.mutation({
      query: (body) => {
        return {
          url: ApiEndParameters.createSpecificationException,
          method: "POST",
          body,
        }
      },
    }),
    upsertProjectAssignmentDetails: builder.mutation({
      query: (body) => {
        return {
          url: ApiEndParameters.upsertProjectAssignmentDetails,
          method: "POST",
          body,
        }
      },
    }),
    upsertSaleInfoDetails: builder.mutation({
      query: (body) => {
        return {
          url: ApiEndParameters.UpsertSaleInfoDetails,
          method: "POST",
          body,
        }
      },
    }),
    createProjectApiForStatusUpdate: builder.mutation({
      query: (body) => {
        return {
          url: ApiEndParameters.createProjectApiForStatusUpdate,
          method: "POST",
          body,
        }
      },
    }),
    updateProjectActions: builder.mutation({
      query: (body) => {
        return {
          url: ApiEndParameters.updateProjectAction,
          method: "POST",
          body,
        }
      },
    }),
    upsertSpecReview: builder.mutation({
      query: (body) => {
        return {
          url: ApiEndParameters.upsertSpecReview,
          method: "POST",
          body,
        }
      },
    }),
    compareOpportunities: builder.mutation({
      query: (body) => {
        return {
          url: ApiEndParameters.compareOpportunities,
          method: "POST",
          body,
        }
      },
    }),
    upsertAcceptedSaleInfoDetails: builder.mutation({
      query: (body) => {
        return {
          url: ApiEndParameters.upsertAcceptedSaleInfoDetails,
          method: "POST",
          body,
        }
      },
    }),
    upsertprojectPermitDetails: builder.mutation({
      query: (body) => {
        return {
          url: ApiEndParameters.upsertprojectPermitDetails,
          method: "POST",
          body,
        }
      },
    }),
    createContactFromProject: builder.mutation({
      query: (body) => {
        return {
          url: ApiEndParameters.createContactFromProject,
          method: "POST",
          body,
        }
      },
    }),
    createProjectAddenda: builder.mutation({
      query: (body) => {
        return {
          url: ApiEndParameters.createProjectAddenda,
          method: "POST",
          body,
        }
      },
    }),
    upsertPromoteToSw: builder.mutation({
      query: (body) => {
        return {
          url: ApiEndParameters.upsertPromoteToSw,
          method: "POST",
          body,
        }
      },
    }),
    upsertAddendaJobScope: builder.mutation({
      query: (body) => {
        return {
          url: ApiEndParameters.upsertAddendaJobScope,
          method: "POST",
          body,
        }
      },
    }),
    upsertPaymentScheduleAddenda: builder.mutation({
      query: (body) => {
        return {
          url: ApiEndParameters.upsertPaymentScheduleAddenda,
          method: "POST",
          body,
        }
      },
    }),
    upsertContactOpportunities: builder.mutation({
      query: (body) => {
        return {
          url: ApiEndParameters.upsertContactOpportunities,
          method: "POST",
          body,
        }
      },
    }),
    uploadProfilePicture: builder.mutation({
      query: (body) => {
        return {
          url: ApiEndParameters.uploadProfilePicture,
          method: "POST",
          body,
        }
      },
    }),
    upsertLeadSource: builder.mutation({
      query: (body) => {
        return {
          url: ApiEndParameters.upsertLeadSource,
          method: "POST",
          body,
        }
      },
    }),
    uploadFile: builder.mutation({
      query: (body: FormData) => {
        return {
          url: ApiEndParameters.uploadFile,
          method: "POST",
          body,
        }
      },
    }),
    createFolder: builder.mutation({
      query: (body) => {
        return {
          url: ApiEndParameters.createFolder,
          method: "POST",
          body,
        }
      },
    }),
    upsertPermitZoning: builder.mutation({
      query: (body) => {
        return {
          url: ApiEndParameters.upsertPermitZoning,
          method: "POST",
          body,
        }
      },
    }),
    upsertPermissionDocument: builder.mutation({
      query: (body) => {
        return {
          url: ApiEndParameters.upsertPermissionsDocument,
          method: "POST",
          body,
        }
      },
    }),
    upsertUserProfileAsync: builder.mutation({
      query: (body) => {
        return {
          url: ApiEndParameters.upsertUserProfileAsync,
          method: "POST",
          body,
        }
      },
    }),
    sendEmail: builder.mutation({
      query: (body: FormData) => {
        return {
          url: ApiEndParameters.sendEmail,
          method: "POST",
          body,
        }
      },
    }),
    sendEmailAfterAction: builder.mutation({
      query: (params) => {
        return {
          url: ApiEndParameters.sendEmailAfterAction,
          method: "POST",
          params
        }
      },
    }),
    sendEmailOfAddenda: builder.mutation({
      query: (params) => {
        return {
          url: ApiEndParameters.sendEmailOfAddenda,
          method: "POST",
          params
        }
      },
    }),
    createCustomFolder: builder.mutation({
      query: (params) => {
        return {
          url: ApiEndParameters.createCustomFolder,
          method: "POST",
          params
        }
      },
    }),
    updateContactDetailsInProject: builder.mutation({
      query: (body) => {
        return {
          url: ApiEndParameters.updateContactDetailsInProject,
          method: "PUT",
          body,
        }
      },
    }),
    getContactLookup: builder.query({
      query: () => {
        return {
          url: ApiEndParameters.contactLookup,
          method: "GET",
        }
      },
    }),
    getAllRoles: builder.query({
      query: (params) => {
        return {
          url: ApiEndParameters.allRoles,
          method: "GET",
          params
        }
      },
    }),
    getCreateUserLookup: builder.query({
      query: () => {
        return {
          url: ApiEndParameters.createUserLookups,
          method: "GET",
        }
      },
    }),
    getAllUsers: builder.query({
      query: (params) => {
        return {
          url: ApiEndParameters.allUsers,
          method: "GET",
          params
        }
      },
    }),
    getOrganizationData: builder.query({
      query: () => {
        return {
          url: ApiEndParameters.organizationData,
          method: "GET",
        }
      },
    }),
    getAllContacts: builder.query({
      query: ({ pageNumber, pageSize, sortBy, sortOrder, searchStr }) => {
        return {
          url: `${ApiEndParameters.allContacts}?PageNumber=${pageNumber}&PageSize=${pageSize}&SortBy=${sortBy}&SortOrder=${sortOrder}&SearchStr=${searchStr}`,
          method: "GET",
        }
      },
    }),
    getAllBusinessUnits: builder.query({
      query: () => {
        return {
          url: ApiEndParameters.businessData,
          method: "GET",
        }
      },
    }),
    getAllTeams: builder.query({
      query: (params) => {
        return {
          url: ApiEndParameters.allTeams,
          method: "GET",
          params
        }
      },
    }),
    getLeadsProspects: builder.query({
      query: (params) => {
        return {
          url: ApiEndParameters.readLeadsProspect,
          method: "GET",
          params
        }
      },
    }),
    getScreenPermissionsByRole: builder.query({
      query: (params) => {
        return {
          url: `${ApiEndParameters.screenPermissionsByRole}`,
          method: "GET",
          params
        }
      },
    }),
    getRolesPermissiosLookup: builder.query({
      query: () => {
        return {
          url: ApiEndParameters.rolesPermissionsLookup,
          method: "GET",
        }
      },
    }),
    getCacheLookupLeads: builder.query({
      query: () => {
        return {
          url: ApiEndParameters.cacheLookupLeads,
          method: "GET",
        }
      },
    }),
    getAccountContactsLookup: builder.query({
      query: () => {
        return {
          url: ApiEndParameters.accountContactsLookup,
          method: "GET",
        }
      },
    }),
    getLeadMarketinglookup: builder.query({
      query: () => {
        return {
          url: ApiEndParameters.LeadMarketinglookup,
          method: "GET",
        }
      },
    }),
    getDefaultlookups: builder.query({
      query: () => {
        return {
          url: ApiEndParameters.getDefaultLookUps,
          method: "GET",
        };
      },
      async onCacheEntryAdded(
        arg,
        { cacheDataLoaded, cacheEntryRemoved, updateCachedData }
      ) {
        const cacheName = "api-cache"; // Cache store name
        const cacheKey = ApiEndParameters.getDefaultLookUps; // Use the URL as the key

        try {
          // Step 1: Open Cache Storage
          const cache = await caches.open(cacheName);

          // Step 2: Check if cached data exists
          const cachedResponse = await cache.match(cacheKey);

          if (cachedResponse) {
            // Step 3: If cached data exists, use it
            const cachedData = await cachedResponse.json();
            updateCachedData((draft) => Object.assign(draft, cachedData.data));
          } else {
            // Step 4: If no cached data, fetch new data from the API
            const { data } = await cacheDataLoaded;
            if (data) {
              // Cache the new API response
              const responseToCache = new Response(JSON.stringify({ data }));
              await cache.put(cacheKey, responseToCache);

              // Update Redux cache with the new data
              updateCachedData((draft) => Object.assign(draft, data));

            }
          }
        } catch (error) {
          console.error("Error fetching or caching data:", error);
        }

        // Clean up when cache entry is removed
        await cacheEntryRemoved;
      }
    }),

    getLeadInquirylookups: builder.query({
      query: () => {
        return {
          url: ApiEndParameters.getleadInquiryLookups,
          method: "GET",
        };
      },
      async onCacheEntryAdded(
        arg,
        { cacheDataLoaded, cacheEntryRemoved, updateCachedData }
      ) {
        const cacheName = "api-cache"; // Cache store name
        const cacheKey = "leadInquiryLookups"; // Key for storing API data in cache

        try {
          // Step 1: Open Cache Storage
          const cache = await caches.open(cacheName);

          // Step 2: Check if cached data exists
          const cachedResponse = await cache.match(cacheKey);

          if (cachedResponse) {
            // Step 3: If cached data exists, use it
            const cachedData = await cachedResponse.json();
            updateCachedData((draft) => Object.assign(draft, cachedData.data));
          } else {
            // Step 4: If no cached data, fetch new data from the API
            const { data } = await cacheDataLoaded;
            if (data) {
              // Cache the new API response
              const responseToCache = new Response(JSON.stringify({ data }));
              await cache.put(cacheKey, responseToCache);

              // Update Redux cache with the new data
              updateCachedData((draft) => Object.assign(draft, data));

            }
          }
        } catch (error) {
          console.error("Error fetching or caching data:", error);
        }

        // Clean up when cache entry is removed
        await cacheEntryRemoved;
      }
    }),

    getActiveAccountLookup: builder.query({
      query: () => {
        return {
          url: ApiEndParameters.getActiveAccountLookup,
          method: "GET",
        }
      },
    }),
    getActiveContactLookup: builder.query({
      query: () => {
        return {
          url: ApiEndParameters.getActiveContactLookup,
          method: "GET",
        }
      },
    }),
    getAssoContactLookup: builder.query({
      query: (params) => {
        return {
          url: ApiEndParameters.getAssoContactLookup,
          method: "GET",
          params
        }
      },
    }),
    getLeadProspectById: builder.query({
      query: ({ prospectId }) => {
        return {
          url: `${ApiEndParameters.leadProspectById}?Id=${prospectId}`,
          method: "GET",
        }
      },
    }),
    getExistingLeadProspectsLookup: builder.query({
      query: (params) => {
        return {
          url: ApiEndParameters.getExistingLeadPospects,
          method: "GET",
          params
        }
      },
    }),
    getAllAccounts: builder.query({
      query: (params) => {
        return {
          url: ApiEndParameters.getAllAccounts,
          method: "GET",
          params
        }
      },
    }),
    getLeadProspectInfobyId: builder.query({
      query: (params) => {
        return {
          url: ApiEndParameters.leadProspectInfo,
          method: "GET",
          params
        }
      },
    }),
    getAllLeadInquiry: builder.query({
      query: (params) => {
        return {
          url: ApiEndParameters.getAllleadInquiry,
          method: "GET",
          params
        }
      },
    }),
    getLeadInquiryDataById: builder.query({
      query: (params) => {
        return {
          url: ApiEndParameters.getLeadInquiryDataById,
          method: "GET",
          params
        }
      },
    }),
    getContactsByAccountId: builder.query({
      query: (params) => {
        return {
          url: ApiEndParameters.getcontactsbyAccount,
          method: "GET",
          params
        }
      },
    }),
    getContactById: builder.query({
      query: (params) => {
        return {
          url: ApiEndParameters.getContactById,
          method: "GET",
          params
        }
      },
    }),
    getAccountById: builder.query({
      query: (params) => {
        return {
          url: ApiEndParameters.getAccountById,
          method: "GET",
          params
        }
      },
    }),
    getModules: builder.query({
      query: () => {
        return {
          url: ApiEndParameters.getModules,
          method: "GET",
        }
      },
    }),
    getSubModules: builder.query({
      query: (params) => {
        return {
          url: ApiEndParameters.getSubModules,
          method: "GET",
          params
        }
      },
    }),
    getAllActiveUsers: builder.query({
      query: (params) => {
        return {
          url: ApiEndParameters.getAllActiveUsers,
          method: "GET",
          params
        }
      },
    }),
    getTeamsbyUserId: builder.query({
      query: (params) => {
        return {
          url: ApiEndParameters.getTeamsByUserId,
          method: "GET",
          params
        }
      },
    }),
    getAppointmentById: builder.query({
      query: (params) => {
        return {
          url: ApiEndParameters.getAppointmentById,
          method: "GET",
          params
        }
      },
    }),
    getAllAppointments: builder.query({
      query: (params) => {
        return {
          url: ApiEndParameters.getAllAppointments,
          method: "GET",
          params
        }
      },
    }),
    getAptResultById: builder.query({
      query: (params) => {
        return {
          url: ApiEndParameters.getAptResultById,
          method: "GET",
          params
        }
      },
    }),
    getAllProjectDetails: builder.query({
      query: (params) => {
        return {
          url: ApiEndParameters.getAllProjectDetails,
          method: "GET",
          params
        }
      },
    }),
    getProjectDetailsbyId: builder.query({
      query: (params) => {
        return {
          url: ApiEndParameters.getProjectDetailsbyId,
          method: "GET",
          params
        }
      },
    }),
    getOpportunityDetailsbyId: builder.query({
      query: (params) => {
        return {
          url: ApiEndParameters.getOpportunityDetailsbyId,
          method: "GET",
          params
        }
      },
    }),
    getAptTitle: builder.query({
      query: (params) => {
        return {
          url: ApiEndParameters.getAptTitle,
          method: "GET",
          params
        }
      },
    }),
    getAllClientVisitDetails: builder.query({
      query: (params) => {
        return {
          url: ApiEndParameters.getAllClientVisitDetails,
          method: "GET",
          params
        }
      },
    }),
    getClientVisitDetailsbyId: builder.query({
      query: (params) => {
        return {
          url: ApiEndParameters.getClientVisitDetailsbyId,
          method: "GET",
          params
        }
      },
    }),
    getProjectLookups: builder.query({
      query: () => {
        return {
          url: ApiEndParameters.getProjectLookups,
          method: "GET",
        }
      },
    }),
    getjobScopeDetailsById: builder.query({
      query: (params) => {
        return {
          url: ApiEndParameters.getJobScoprDetailById,
          method: "GET",
          params
        }
      },
    }),
    getProjectNotesById: builder.query({
      query: (params) => {
        return {
          url: ApiEndParameters.getProjectNotesById,
          method: "GET",
          params
        }
      },
    }),
    getAllProjectNotes: builder.query({
      query: (params) => {
        return {
          url: ApiEndParameters.getAllProjectNotes,
          method: "GET",
          params
        }
      },
    }),
    getAllContigency: builder.query({
      query: (params) => {
        return {
          url: ApiEndParameters.getAllContigency,
          method: "GET",
          params
        }
      },
    }),

    getContigencyById: builder.query({
      query: (params) => {
        return {
          url: ApiEndParameters.getContigencyById,
          method: "GET",
          params
        }
      },
    }),
    getAllProjectTasks: builder.query({
      query: (params) => {
        return {
          url: ApiEndParameters.getAllProjectTasks,
          method: "GET",
          params
        }
      },
    }),
    getProjectTaskById: builder.query({
      query: (params) => {
        return {
          url: ApiEndParameters.getProjectTaskByID,
          method: "GET",
          params
        }
      },
    }),
    getFundingDetailsById: builder.query({
      query: (params) => {
        return {
          url: ApiEndParameters.getFundingDetailsById,
          method: "GET",
          params
        }
      },
    }),
    getjobScopeHistory: builder.query({
      query: (params) => {
        return {
          url: ApiEndParameters.getJobScopeHistory,
          method: "GET",
          params
        }
      },
    }),
    getSpecificationException: builder.query({
      query: (params) => {
        return {
          url: ApiEndParameters.getSpecificationException,
          method: "GET",
          params
        }
      },
    }),
    getTeamMemberByName: builder.query({
      query: (params) => {
        return {
          url: ApiEndParameters.getTeamMemberByName,
          method: "GET",
          params
        }
      },
    }),
    getTeamMemberByRole: builder.query({
      query: (params) => {
        return {
          url: ApiEndParameters.getTeamMemberByRole,
          method: "GET",
          params
        }
      },
    }),
    teamDetailsInProject: builder.query({
      query: (params) => {
        return {
          url: ApiEndParameters.teamDetailsInProject,
          method: "GET",
          params
        }
      },
    }),
    getSystemSuggestionDetails: builder.query({
      query: (params) => {
        return {
          url: ApiEndParameters.systemSuggestionDetails,
          method: "GET",
          params
        }
      },
    }),
    getEnterpriseMemberByRole: builder.query({
      query: (params) => {
        return {
          url: ApiEndParameters.getEnterpriseMemberByRole,
          method: "GET",
          params
        }
      },
    }),
    getEnterpriseMemberByName: builder.query({
      query: (params) => {
        return {
          url: ApiEndParameters.getEnterpriseMemberByName,
          method: "GET",
          params
        }
      },
    }),
    getAllAssignment: builder.query({
      query: (params) => {
        return {
          url: ApiEndParameters.getAllAssignments,
          method: "GET",
          params
        }
      },
    }),
    getAssignmentDetailById: builder.query({
      query: (params) => {
        return {
          url: ApiEndParameters.getAssignmentDetailById,
          method: "GET",
          params
        }
      },
    }),
    GetFirstAPSNest: builder.query({
      query: (params) => {
        return {
          url: ApiEndParameters.GetFirstAPSNest,
          method: "GET",
          params
        }
      },
    }),
    GetSecondAPSNest: builder.query({
      query: (params) => {
        return {
          url: ApiEndParameters.GetSecondAPSNest,
          method: "GET",
          params
        }
      },
    }),
    GetThirdAPSNest: builder.query({
      query: (params) => {
        return {
          url: ApiEndParameters.GetThirdAPSNest,
          method: "GET",
          params
        }
      },
    }),
    GetWizardActions: builder.query({
      query: (params) => {
        return {
          url: ApiEndParameters.GetWizardActions,
          method: "GET",
          params
        }
      },
    }),
    GetWizardTabs: builder.query({
      query: (params) => {
        return {
          url: ApiEndParameters.GetWizardTabs,
          method: "GET",
          params
        }
      },
    }),
    GetSaleInfoById: builder.query({
      query: (params) => {
        return {
          url: ApiEndParameters.GetSaleInfoById,
          method: "GET",
          params
        }
      },
    }),
    GetContactDetailsInProject: builder.query({
      query: (params) => {
        return {
          url: ApiEndParameters.GetContactDetailsInProject,
          method: "GET",
          params
        }
      },
    }),
    getSpecReason: builder.query({
      query: (params) => {
        return {
          url: ApiEndParameters.getSpecReason,
          method: "GET",
          params
        }
      },
    }),
    getAcceptedSaledInfoById: builder.query({
      query: (params) => {
        return {
          url: ApiEndParameters.getAcceptedSaledInfoById,
          method: "GET",
          params
        }
      },
    }),
    getPermitById: builder.query({
      query: (params) => {
        return {
          url: ApiEndParameters.getPermitById,
          method: "GET",
          params
        }
      },
    }),
    getAddendaById: builder.query({
      query: (params) => {
        return {
          url: ApiEndParameters.getAddendaById,
          method: "GET",
          params
        }
      },
    }),
    getAllAddenda: builder.query({
      query: (params) => {
        return {
          url: ApiEndParameters.getAllAddenda,
          method: "GET",
          params
        }
      },
    }),
    getPromoteToSw: builder.query({
      query: (params) => {
        return {
          url: ApiEndParameters.getPromoteToSw,
          method: "GET",
          params
        }
      },
    }),
    getAddendaJobScopeById: builder.query({
      query: (params) => {
        return {
          url: ApiEndParameters.getAddendaJobScopeById,
          method: "GET",
          params
        }
      },
    }),
    getPaymentScheduleAddendaById: builder.query({
      query: (params) => {
        return {
          url: ApiEndParameters.getPaymentScheduleAddendaById,
          method: "GET",
          params
        }
      },
    }),
    getContactOpportunitiesById: builder.query({
      query: (params) => {
        return {
          url: ApiEndParameters.getContactOpportunitiesById,
          method: "GET",
          params
        }
      },
    }),
    getLocation: builder.query({
      query: (params) => {
        return {
          url: ApiEndParameters.getLocation,
          method: "GET",
          params
        }
      },
    }),
    getProjectFolders: builder.query({
      query: (params) => {
        return {
          url: ApiEndParameters.projectFolders,
          method: "GET",
          params
        }
      },
    }),
    clientViewSummary: builder.query({
      query: (params) => {
        return {
          url: ApiEndParameters.clientViewSummary,
          method: "GET",
          params
        }
      },
    }),
    getFirstAptTicket: builder.query({
      query: (params) => {
        return {
          url: ApiEndParameters.firstAptTicket,
          method: "GET",
          params
        }
      },
    }),
    getjobCard: builder.query({
      query: (params) => {
        return {
          url: ApiEndParameters.jobCard,
          method: "GET",
          params
        }
      },
    }),
    getPermitZoning: builder.query({
      query: (params) => {
        return {
          url: ApiEndParameters.getPermitZoning,
          method: "GET",
          params
        }
      },
    }),
    getAddendaAgreement: builder.query({
      query: (params) => {
        return {
          url: ApiEndParameters.addendaAggrement,
          method: "GET",
          params
        }
      },
    }),
    getApptConfirmation: builder.query({
      query: (params) => {
        return {
          url: ApiEndParameters.apptConfirmationLetter,
          method: "GET",
          params
        }
      },
    }),
    getPermissionsDocuments: builder.query({
      query: (params) => {
        return {
          url: ApiEndParameters.getPermissionDocument,
          method: "GET",
          params
        }
      },
    }),
    getLocationDetailsByAggress: builder.query({
      query: (params) => {
        return {
          url: ApiEndParameters.getLocationDetailsByAddress,
          method: "GET",
          params
        }
      },
    }),
    GetListingFiltersLookUps: builder.query({
      query: (params) => {
        return {
          url: ApiEndParameters.GetListingFiltersLookUps,
          method: "GET",
          params
        }
      },
    }),
    getTeamMembersEmail: builder.query({
      query: (params) => {
        return {
          url: ApiEndParameters.getTeamMembersEmail,
          method: "GET",
          params
        }
      },
    }),
    taskTypeLookup: builder.query({
      query: (params) => {
        return {
          url: ApiEndParameters.taskTypeLookup,
          method: "GET",
          params
        }
      },
    }),
    actionLookupPermission: builder.query({
      query: (params) => {
        return {
          url: ApiEndParameters.actionLookupPermission,
          method: "GET",
          params
        }
      },
    }),
    getRegionAndSite: builder.query({
      query: (params) => {
        return {
          url: ApiEndParameters.getRegionAndSite,
          method: "GET",
          params
        }
      },
    }),
    documentImagePreview: builder.query({
      query: (params) => {
        return {
          url: ApiEndParameters.documentImagePreview,
          method: "GET",
          params
        }
      },
    }),
    getAddendaStatusLookup: builder.query({
      query: (params) => {
        return {
          url: ApiEndParameters.getAddendaStatusLookup,
          method: "GET",
          params
        }
      },
    }),
    getprintoutPdfDetails: builder.query({
      query: (params) => {
        return {
          url: ApiEndParameters.getprintoutPdfDetails,
          method: "GET",
          params
        }
      },
    }),
    getProjectBinderCover: builder.query({
      query: (params) => {
        return {
          url: ApiEndParameters.getProjectBinderCover,
          method: "GET",
          responseHandler: (response: any) => response.blob(),
          params
        }
      },
    }),
    getProjectCutSheetLabel: builder.query({
      query: (params) => {
        return {
          url: ApiEndParameters.getProjectCutSheetLabel,
          method: "GET",
          responseHandler: (response: any) => response.blob(),
          params
        }
      },
    }),
    getUrlByMunicipality: builder.query({
      query: (params) => {
        return {
          url: ApiEndParameters.getUrlByMunicipality,
          method: "GET",
          params
        }
      },
    }),
    getTemplates: builder.query({
      query: (params) => {
        return {
          url: ApiEndParameters.templates,
          method: "GET",
          responseHandler: (response: any) => response.blob(),
          params
        }
      },
    }),
    getCompanyInfo: builder.query({
      query: (params) => {
        return {
          url: ApiEndParameters.getCompanyInfo,
          method: "GET",
          params
        }
      },
    }),
    getProjectGraph: builder.query({
      query: (params) => {
        return {
          url: ApiEndParameters.projectGraph,
          method: "GET",
          params
        }
      },
    }),
    getProjectReportList: builder.query({
      query: (params) => {
        return {
          url: ApiEndParameters.projectReportList,
          method: "GET",
          params
        }
      },
    }),
    getDrcSignReviewSurveyDetails: builder.query({
      query: (params) => {
        return {
          url: ApiEndParameters.getDrcSignReviewSurveyDetails,
          method: "GET",
          params
        }
      },
    }),
    getPccReviewSurveyDetails: builder.query({
      query: (params) => {
        return {
          url: ApiEndParameters.getPccReviewSurveyDetails,
          method: "GET",
          params
        }
      },
    }),
    getReportPDMActSummary: builder.query({
      query: (params) => {
        return {
          url: ApiEndParameters.getReportPDMActSummary,
          method: "GET",
          params
        }
      },
    }),
    getReportAllCompanies: builder.query({
      query: () => {
        return {
          url: ApiEndParameters.getReportAllCompanies,
          method: "GET",
        }
      },
    }),
    getReportAllPDMs: builder.query({
      query: () => {
        return {
          url: ApiEndParameters.getReportAllPDMs,
          method: "GET",
        }
      },
    }),
    getReportPerformanceMatrixView: builder.query({
      query: (params) => {
        return {
          url: ApiEndParameters.getReportPerformanceMatrixView,
          method: "GET",
          params
        }
      },
    }),
    getEcdReviewSurveyDetails: builder.query({
      query: (params) => {
        return {
          url: ApiEndParameters.getEcdReviewSurveyDetails,
          method: "GET",
          params
        }
      },
    }),
    getSiteAndRegionbyZip: builder.query({
      query: (params) => {
        return {
          url: ApiEndParameters.getSiteAndRegionbyZip,
          method: "GET",
          params
        }
      },
    }),
     getEnterpriseReport: builder.query({
      query: (params) => {
        return {
          url: ApiEndParameters.getEnterpriseReport,
          method: "GET",
          params
        }
      },
    }),
     getuserProfile: builder.query({
      query: (params) => {
        return {
          url: ApiEndParameters.userProfile,
          method: "GET",
          params
        }
      },
    }),
    updateUserProfile: builder.mutation({
      query: (body) => {
        return {
          url: ApiEndParameters.userUpdateProfile,
          method: "PUT",
          body
        }
      },
    }),
    updateTeams: builder.mutation({
      query: (body) => {
        return {
          url: ApiEndParameters.updateTeam,
          method: "PUT",
          body,
        }
      },
    }),
    updateTemplate: builder.mutation({
      query: (body) => {
        return {
          url: ApiEndParameters.updateTemplate,
          method: "PUT",
          body,
        }
      },
    }),

    updateContact: builder.mutation({
      query: (body) => {
        return {
          url: ApiEndParameters.updateContact,
          method: "PUT",
          body,
        }
      },
    }),
    updateAccount: builder.mutation({
      query: (body) => {
        return {
          url: ApiEndParameters.updateAccount,
          method: "PUT",
          body,
        }
      },
    }),
    updateLeadProspect: builder.mutation({
      query: (body) => {
        return {
          url: ApiEndParameters.UpdateLeadProspect,
          method: "PUT",
          body,
        }
      },
    }),
    updateLeadInquiry: builder.mutation({
      query: (body) => {
        return {
          url: ApiEndParameters.updateLeadInquiry,
          method: "PUT",
          body,
        }
      },
    }),
    updateLeadAssignTo: builder.mutation({
      query: (body) => {
        return {
          url: ApiEndParameters.updateLeadAssignTo,
          method: "PUT",
          body,
        }
      },
    }),

    updateRoleWisePermissions: builder.mutation({
      query: (body) => {
        return {
          url: ApiEndParameters.updateRoleWisePermissions,
          method: "PUT",
          body,
        }
      },
    }),
    deleteLeadPropect: builder.mutation({
      query: (params) => {
        return {
          url: ApiEndParameters.deleteLeadProspect,
          method: "PUT",
          params,
        }
      },
    }),
    deleteLeadInquiry: builder.mutation({
      query: (params) => {
        return {
          url: ApiEndParameters.deleteLeadInquiry,
          method: "PUT",
          params,
        }
      },
    }),
    updateAppointment: builder.mutation({
      query: (body) => {
        return {
          url: ApiEndParameters.updateAppointment,
          method: "PUT",
          body,
        }
      },
    }),
    updateAptResult: builder.mutation({
      query: (body) => {
        return {
          url: ApiEndParameters.updateAptResult,
          method: "PUT",
          body,
        }
      },
    }),
    updateProjectAddenda: builder.mutation({
      query: (body) => {
        return {
          url: ApiEndParameters.updateProjectAddenda,
          method: "PUT",
          body,
        }
      },
    }),
    forgotPassword: builder.mutation({
      query: (body) => {
        return {
          url: ApiEndParameters.forgotPassword,
          method: "PUT",
          body,
        }
      },
    }),
    updatePassword: builder.mutation({
      query: (body) => {
        return {
          url: ApiEndParameters.updatePassword,
          method: "PUT",
          body,
        }
      },
    }),
    removeUserAssignment: builder.mutation({
      query: (params) => {
        return {
          url: ApiEndParameters.removeUserAssignment,
          method: "PUT",
          params,
        }
      },
    }),
    updateCompanyInfo: builder.mutation({
      query: (body) => {
        return {
          url: ApiEndParameters.updateCompanyInfo,
          method: "PUT",
          body,
        }
      },
    }),
    updateOrganization: builder.mutation({
      query: (body) => {
        return {
          url: ApiEndParameters.updateOrganiazation,
          method: "PATCh",
          body,
        }
      },
    }),
    deactivateUserToggle: builder.mutation({
      query: (body) => {
        return {
          url: ApiEndParameters.deactivateUserToggle,
          method: "PATCH",
          body,
        }
      },
    }),
    activeInactiveRoles: builder.mutation({
      query: (body) => {
        return {
          url: ApiEndParameters.activeInActiveRoles,
          method: "PATCH",
          body,
        }
      },
    }),
    activeInactiveTeams: builder.mutation({
      query: (body) => {
        return {
          url: ApiEndParameters.activeInActiveTeams,
          method: "PATCH",
          body,
        }
      },
    }),
    activeInactiveContacts: builder.mutation({
      query: (body) => {
        return {
          url: ApiEndParameters.activateDeactiveContact,
          method: "PATCH",
          body,
        }
      },
    }),

    updateProjectDetails: builder.mutation({
      query: (body) => {
        return {
          url: ApiEndParameters.updateProjectDetails,
          method: "PUT",
          body,
        }
      },
    }),

    upsertOpportunityDetails: builder.mutation({
      query: (body) => {
        return {
          url: ApiEndParameters.upsertOpportunityDetails,
          method: "POST",
          body,
        }
      },
    }),

    updateClientVisitDetails: builder.mutation({
      query: (body) => {
        return {
          url: ApiEndParameters.updateClientVisitDetails,
          method: "PUT",
          body,
        }
      },
    }),
    createClientVisitDetails: builder.mutation({
      query: (body) => {
        return {
          url: ApiEndParameters.createClientVisitDetails,
          method: "POST",
          body,
        }
      },
    }),
    upsertECDReviewSurvey: builder.mutation({
      query: (body) => {
        return {
          url: ApiEndParameters.upsertECDReviewSurvey,
          method: "POST",
          body,
        }
      },
    }),
    upsertDrcSignReviewSurvey: builder.mutation({
      query: (body) => {
        return {
          url: ApiEndParameters.upsertDrcSignReviewSurvey,
          method: "POST",
          body,
        }
      },
    }),
    upsertPccReviewSurvey: builder.mutation({
      query: (body) => {
        return {
          url: ApiEndParameters.upsertPccReviewSurvey,
          method: "POST",
          body,
        }
      },
    }),

  }),
})

export const {
  useLoginUserMutation,
  useCreateUserMutation,
  useCreateContactMutation,
  useGetContactLookupQuery,
  useGetAllRolesQuery,
  useGetCreateUserLookupQuery,
  useGetAllUsersQuery,
  useDeactivateUserToggleMutation,
  useGetOrganizationDataQuery,
  useUpdateOrganizationMutation,
  useGetAllContactsQuery,
  useGetAllBusinessUnitsQuery,
  useCreateTeamMutation,
  useGetAllTeamsQuery,
  useUpdateTeamsMutation,
  useCreateRoleWisePermissionsMutation,
  useGetScreenPermissionsByRoleQuery,
  useUpdateContactMutation,
  useGetRolesPermissiosLookupQuery,
  useLazyGetScreenPermissionsByRoleQuery,
  useActiveInactiveRolesMutation,
  useCreateLeadMutation,
  useGetCacheLookupLeadsQuery,
  useGetLeadsProspectsQuery,
  useCreateAccountMutation,
  useGetAccountContactsLookupQuery,
  useUpdateAccountMutation,
  useActiveInactiveTeamsMutation,
  useActiveInactiveContactsMutation,
  useGetLeadMarketinglookupQuery,
  useGetDefaultlookupsQuery,
  useGetActiveAccountLookupQuery,
  useGetActiveContactLookupQuery,
  useGetAssoContactLookupQuery,
  useLazyGetAssoContactLookupQuery,
  useGetLeadProspectByIdQuery,
  useLazyGetLeadProspectByIdQuery,
  useGetExistingLeadProspectsLookupQuery,
  useLazyGetLeadsProspectsQuery,
  useGetAllAccountsQuery,
  useUpdateLeadProspectMutation,
  useGetContactByIdQuery,
  useLazyGetContactByIdQuery,
  useGetAccountByIdQuery,
  useLazyGetLeadProspectInfobyIdQuery,
  useGetAllLeadInquiryQuery,
  useGetLeadInquiryDataByIdQuery,
  useUpdateLeadInquiryMutation,
  useGetLeadInquirylookupsQuery,
  useGetModulesQuery,
  useGetSubModulesQuery,
  useUpdateRoleWisePermissionsMutation,
  useGetContactsByAccountIdQuery,
  useLazyGetContactsByAccountIdQuery,
  useLazyGetAccountByIdQuery,
  useGetAllActiveUsersQuery,
  useLazyGetTeamsbyUserIdQuery,
  useUpdateLeadAssignToMutation,
  useDeleteLeadInquiryMutation,
  useDeleteLeadPropectMutation,
  useCreateAppointmentMutation,
  useUpdateAppointmentMutation,
  useGetAppointmentByIdQuery,
  useLazyGetAppointmentByIdQuery,
  useGetAllAppointmentsQuery,
  useCreateAppointmentResultMutation,
  useGetAptResultByIdQuery,
  useLazyGetAptResultByIdQuery,
  useGetAllProjectDetailsQuery,
  useGetProjectDetailsbyIdQuery,
  useUpdateProjectDetailsMutation,
  useGetOpportunityDetailsbyIdQuery,
  useUpsertOpportunityDetailsMutation,
  useUpdateAptResultMutation,
  useGetAllClientVisitDetailsQuery,
  useGetClientVisitDetailsbyIdQuery,
  useUpdateClientVisitDetailsMutation,
  useCreateClientVisitDetailsMutation,
  useGetProjectLookupsQuery,
  useGetAptTitleQuery,
  useGetjobScopeDetailsByIdQuery,
  useUpsertJobScopeMutation,
  useGetAllProjectNotesQuery,
  useLazyGetAllProjectNotesQuery,
  useGetProjectNotesByIdQuery,
  useLazyGetProjectNotesByIdQuery,
  useUpsertProjectNotesMutation,
  useCreateUpdateContigencyMutation,
  useGetAllContigencyQuery,
  useGetContigencyByIdQuery,
  useCreateUpdateProjectTasksMutation,
  useGetAllProjectTasksQuery,
  useLazyGetContigencyByIdQuery,
  useLazyGetProjectTaskByIdQuery,
  useCreateUpdateFundingMutation,
  useGetFundingDetailsByIdQuery,
  useLazyGetFundingDetailsByIdQuery,
  useGetjobScopeHistoryQuery,
  useCreateUpdateSpecificationExceptionMutation,
  useGetSpecificationExceptionQuery,
  useUpsertProjectAssignmentDetailsMutation,
  useGetTeamMemberByNameQuery,
  useGetTeamMemberByRoleQuery,
  useLazyGetTeamMemberByNameQuery,
  useLazyGetTeamMemberByRoleQuery,
  useTeamDetailsInProjectQuery,
  useLazyTeamDetailsInProjectQuery,
  useGetSystemSuggestionDetailsQuery,
  useGetEnterpriseMemberByNameQuery,
  useGetEnterpriseMemberByRoleQuery,
  useLazyGetEnterpriseMemberByNameQuery,
  useLazyGetEnterpriseMemberByRoleQuery,
  useGetAllAssignmentQuery,
  useGetAssignmentDetailByIdQuery,
  useLazyGetAssignmentDetailByIdQuery,
  useGetFirstAPSNestQuery,
  useGetSecondAPSNestQuery,
  useGetThirdAPSNestQuery,
  useGetWizardActionsQuery,
  useLazyGetWizardActionsQuery,
  useGetWizardTabsQuery,
  useLazyGetWizardTabsQuery,
  useUpsertSaleInfoDetailsMutation,
  useGetSaleInfoByIdQuery,
  useLazyGetSaleInfoByIdQuery,
  useGetContactDetailsInProjectQuery,
  useLazyGetContactDetailsInProjectQuery,
  useUpdateContactDetailsInProjectMutation,
  useCreateProjectApiForStatusUpdateMutation,
  useGetReportPDMActSummaryQuery,
  useLazyGetReportPDMActSummaryQuery,
  useGetReportAllCompaniesQuery,
  useGetReportAllPDMsQuery,
  useGetReportPerformanceMatrixViewQuery,
  useUpdateProjectActionsMutation,
  useUpsertSpecReviewMutation,
  useGetSpecReasonQuery,
  useCompareOpportunitiesMutation,
  useUpsertAcceptedSaleInfoDetailsMutation,
  useGetAcceptedSaledInfoByIdQuery,
  useGetPermitByIdQuery,
  useUpsertprojectPermitDetailsMutation,
  useGetEcdReviewSurveyDetailsQuery,
  useLazyGetEcdReviewSurveyDetailsQuery,
  useUpsertECDReviewSurveyMutation,
  useGetDrcSignReviewSurveyDetailsQuery,
  useUpsertDrcSignReviewSurveyMutation,
  useGetPccReviewSurveyDetailsQuery,
  useUpsertPccReviewSurveyMutation,
  useCreateContactFromProjectMutation,
  useCreateProjectAddendaMutation,
  useUpdateProjectAddendaMutation,
  useGetAddendaByIdQuery,
  useLazyGetAddendaByIdQuery,
  useGetAllAddendaQuery,
  useUpsertPromoteToSwMutation,
  useGetPromoteToSwQuery,
  useUpsertAddendaJobScopeMutation,
  useGetAddendaJobScopeByIdQuery,
  useLazyGetAddendaJobScopeByIdQuery,
  useUpsertPaymentScheduleAddendaMutation,
  useGetPaymentScheduleAddendaByIdQuery,
  useGetContactOpportunitiesByIdQuery,
  useUpsertContactOpportunitiesMutation,
  useUpsertLeadSourceMutation,
  useLazyGetLocationQuery,
  useRenewTokenMutation,
  useGetProjectFoldersQuery,
  useUploadProfilePictureMutation,
  useClientViewSummaryQuery,
  useGetFirstAptTicketQuery,
  useCreateFolderMutation,
  useUploadFileMutation,
  useGetjobCardQuery,
  useGetPermitZoningQuery,
  useUpsertPermitZoningMutation,
  useLazyGetAddendaAgreementQuery,
  useGetAddendaAgreementQuery,
  useGetApptConfirmationQuery,
  useGetPermissionsDocumentsQuery,
  useUpsertPermissionDocumentMutation,
  useLazyGetLocationDetailsByAggressQuery,
  useLazyGetPermissionsDocumentsQuery,
  useUpsertUserProfileAsyncMutation,
  useUpdateTemplateMutation,
  useGetListingFiltersLookUpsQuery,
  useLazyGetAllProjectDetailsQuery,
  useSendEmailMutation,
  useGetTeamMembersEmailQuery,
  useLazyGetTeamMembersEmailQuery,
  useSendEmailAfterActionMutation,
  useSendEmailOfAddendaMutation,
  useTaskTypeLookupQuery,
  useActionLookupPermissionQuery,
  useLazyGetRegionAndSiteQuery,
  useForgotPasswordMutation,
  useUpdatePasswordMutation,
  useCreateCustomFolderMutation,
  useRemoveUserAssignmentMutation,
  useDocumentImagePreviewQuery,
  useLazyDocumentImagePreviewQuery,
  useGetAddendaStatusLookupQuery,
  useGetprintoutPdfDetailsQuery,
  useLazyGetProjectBinderCoverQuery,
  useLazyGetProjectCutSheetLabelQuery,
  useLazyGetUrlByMunicipalityQuery,
  useGetTemplatesQuery,
  useLazyGetTemplatesQuery,
  useGetCompanyInfoQuery,
  useGetProjectGraphQuery,
  useLazyGetProjectGraphQuery,
  useUpdateCompanyInfoMutation,
  useGetProjectReportListQuery,
  useGetRegionAndSiteQuery,
  useGetEnterpriseReportQuery,
  useLazyGetEnterpriseReportQuery,
  useLazyGetSiteAndRegionbyZipQuery,
  useGetuserProfileQuery,
  useUpdateUserProfileMutation,
} = EndPointsApis